import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Settings } from 'lucide-react';
export function WhatWeDeliver() {
  const features = [{
    icon: <Zap className="h-8 w-8 text-brand-green" data-id="element-269" />,
    title: '80% Faster Software Transformation',
    description: 'Accelerate migrations, upgrades, conversions, and modernization initiatives with AI-powered engineering accelerators and disciplined execution.'
  }, {
    icon: <Settings className="h-8 w-8 text-brand-blue" data-id="element-270" />,
    title: 'Better Quality Through Engineering Automation',
    description: 'Improve software quality with automated testing, increased code coverage, better documentation, CI/CD pipelines, and standardized engineering practices.'
  }, {
    icon: <ShieldCheck className="h-8 w-8 text-brand-navyLight" data-id="element-271" />,
    title: 'Secure & Reliable Engineering',
    description: 'Strengthen software reliability through better architecture, secure engineering practices, controlled delivery pipelines, and continuous validation.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="deliver" className="py-24 bg-slate-50" data-id="element-272">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-274">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 font-heading" data-id="element-275">
            Why BetterCode?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-276">
            BetterCode combines AI-powered tools, engineering accelerators,
            proven processes, and expert teams to modernize software systems
            faster, safer, and with better long-term quality.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-3 gap-8" data-id="element-277">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300" data-id="element-278">
              <div className="mb-6 bg-slate-50 w-16 h-16 rounded-lg flex items-center justify-center" data-id="element-279">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4 font-heading" data-id="element-280">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-281">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}